import {Popover} from "bootstrap";

export default function(root) {
	Array.from(root.querySelectorAll('[data-bs-toggle="popover"]'))
		.forEach(popoverNode => {
			popoverNode.addEventListener('click', (e) => {
				e.preventDefault()
			})

			new Popover(popoverNode, {
				trigger: 'click'
			})

			const autohide = popoverNode.dataset.bsAutohide
			if (autohide && (autohide === "true" || parseInt(autohide) > 0)) {
				popoverNode.addEventListener('show.bs.popover', () => {
					setTimeout(() => {
						Popover.getInstance(popoverNode).hide()
					}, autohide === "true" ? 5000 : parseInt(autohide))
				})
			}
		})
}
